import { Component, Input } from '@angular/core';
import { TableComponent } from '../../../../core/table/table.component';
import { ColumnComponent } from '../../../../core/table/column.component';

@Component({
  selector: 'app-aggregate-limit',
  imports: [TableComponent, ColumnComponent],
  template: `<div class="tw-flex tw-gap-8">
    <div class="tw-basis-full">
      <app-table
        [dataSource]="dataSource"
        [pageSize]="5"
        [scrollable]="false"
        [stripedRows]="false"
        recordLabel="Aggregate Limit"
        [globalFilterFields]="[
          'appliesTo',
          'limitAmount',
          'aggregateType',
          'limitType',
          'comments',
        ]"
      >
        <app-column name="appliesTo" label="Applies To" width="20%" />
        <app-column
          name="limitAmount"
          label="Limit Amount"
          format="c"
          width="20%"
        />
        <app-column name="aggregateType" label="Aggregate Type" width="20%" />
        <app-column name="limitType" label="Limit Description" width="20%" />
        <app-column
          label="Comments"
          name="comments"
          [fullRow]="true"
          [fullRowLabel]="true"
        >
          <ng-template #item let-row>
            <span class="tw-text-wrap tw-leading-6">{{ row.comments }}</span>
          </ng-template>
        </app-column>
      </app-table>
    </div>
  </div>`,
  styles: [``],
})
export class PolicyAggregateLimitComponent {
  @Input()
  dataSource: any;
}
